import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * Componente per proteggere le route che richiedono autenticazione.
 * Redirige alla pagina di login se l'utente non è autenticato.
 */
export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Mostra loading durante verifica autenticazione
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.2rem'
      }}>
        Caricamento...
      </div>
    );
  }

  // Redirige al login se non autenticato
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Renderizza il contenuto protetto
  return <>{children}</>;
};
